module.exports = __webpack_public_path__ + "img/offline.60347e45.svg";